import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Index from "@/pages/Index";
import PaydayLoans from "@/pages/PaydayLoans";
import PersonalLoans from "@/pages/PersonalLoans";
import InstallmentLoans from "@/pages/InstallmentLoans";
import CashAdvances from "@/pages/CashAdvances";
import TitleLoans from "@/pages/TitleLoans";
import HowItWorks from "@/pages/HowItWorks";
import FAQ from "@/pages/FAQ";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Index />,
  },
  {
    path: "/payday-loans",
    element: <PaydayLoans />,
  },
  {
    path: "/personal-loans",
    element: <PersonalLoans />,
  },
  {
    path: "/installment-loans",
    element: <InstallmentLoans />,
  },
  {
    path: "/cash-advances",
    element: <CashAdvances />,
  },
  {
    path: "/title-loans",
    element: <TitleLoans />,
  },
  {
    path: "/how-it-works",
    element: <HowItWorks />,
  },
  {
    path: "/faq",
    element: <FAQ />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

export function BrowserRouter({ children }: { children: React.ReactNode }) {
  return <RouterProvider router={router} />;
}

export { Link, useNavigate, useLocation } from "react-router-dom";